var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{staticClass:"d-flex m-0 font-weight-bold fs-6 text-white overflow-auto m-0"},[_vm._v("    "),_c('code',{staticClass:"typer"},[_vm._v(_vm._s(_vm.text))]),_vm._v("\n")])}
var staticRenderFns = []

export { render, staticRenderFns }